import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"
import {FacetState} from "../../../../../models/FacetsState"

export interface SingleFacetCountWrapperProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    facet: FacetState
    childtestid: string
}

const SingleFacetCountWrapper = memo(({templating, facet, childtestid}: SingleFacetCountWrapperProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName facet={facet} childtestid={childtestid} />
        </Suspense>
    )
})
SingleFacetCountWrapper.displayName = "SingleFacetCountWrapper"

export default connect(SingleFacetCountWrapper)
